// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-tests-view .el-collapse-item__header {\n  line-height: 1.2;\n}\n.add-tests-view .content .all-tests .each-test .each-check-box .el-checkbox {\n  display: flex;\n  align-items: flex-start;\n}\n.add-tests-view .content .all-tests .each-test .each-check-box .el-checkbox__label {\n  white-space: normal;\n  word-wrap: break-word;\n}", ""]);
// Exports
module.exports = exports;
